var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobalSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.002 16.002C22.002 17.1887 21.6501 18.3487 20.9908 19.3354C20.3315 20.3221 19.3944 21.0911 18.2981 21.5453C17.2017 21.9994 15.9953 22.1182 14.8314 21.8867C13.6675 21.6552 12.5984 21.0838 11.7593 20.2446C10.9202 19.4055 10.3488 18.3364 10.1172 17.1725C9.88573 16.0087 10.0046 14.8023 10.4587 13.7059C10.9128 12.6095 11.6818 11.6725 12.6685 11.0132C13.6552 10.3539 14.8153 10.002 16.002 10.002C17.5933 10.002 19.1194 10.6341 20.2446 11.7594C21.3698 12.8846 22.002 14.4107 22.002 16.002Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.998 25.997L21.74 21.739",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSearchIcon);
export default __webpack_public_path__ + "static/media/GlobalSearchIcon.69ac571df915ceaba92ddcb0e00c1b92.svg";
export { ForwardRef as ReactComponent };